import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import moment from 'moment';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PaymentRow } from './PaymentRow';

const StepThreeTabOne = ({
  paymentDataList = [],
  setPaymentDataList = () => {},
  currency,
}) => {
  const { t } = useTranslation();

  // Memoized payment list (referensiya o'zgarmasligi uchun)
  const stablePaymentList = useMemo(
    () => [...paymentDataList],
    [paymentDataList],
  );

  // ==================== HANDLERS (Stable - yangi funksiya yaratilmaydi) ====================
  const handlePaymentDate = useCallback(
    (newDate, id) => {
      if (!newDate || !id) return;

      setPaymentDataList((prevList) =>
        prevList.map((item) =>
          item.id === id ? { ...item, date: newDate } : item,
        ),
      );
    },
    [setPaymentDataList],
  );

  const handlePaymentPrice = useCallback(
    (newSum, id) => {
      if (isNaN(newSum) || !id) return;

      setPaymentDataList((prevList) => {
        const updated = [...prevList];
        const rowIndex = updated.findIndex((item) => item.id === id);

        if (rowIndex === -1) return prevList;

        updated[rowIndex].sum = newSum;

        // Oxirgi to'lov bo'lmasa - qolganlarni qayta hisoblaymiz
        if (rowIndex < updated.length - 1) {
          let remaining = updated[rowIndex].left - newSum; // oldingi qoldiqdan yangi to'lovni ayiramiz

          for (let i = rowIndex + 1; i < updated.length; i++) {
            updated[i].left = remaining;
            if (i === updated.length - 1) {
              updated[i].sum = remaining; // oxirgi to'lovda hammasi qoldiq
            } else {
              const remainingMonths = updated.length - i;
              updated[i].sum = Math.floor(remaining / remainingMonths);
              remaining -= updated[i].sum;
            }
          }
        }

        return updated;
      });
    },
    [setPaymentDataList],
  );

  const handleDateError = useCallback((value) => {
    if (!value) return false;
    const m = moment(value);
    return !m.isValid() || m.isBefore('2000-01-01');
  }, []);

  // Har bir qator uchun alohida memo komponent yaratamiz (eng muhim optimallashtirish!)

  const [i, setI] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      if (i < stablePaymentList?.length) setI(i + 1);
    }, 100);
    return () => clearInterval(interval);
  }, [stablePaymentList?.length, i]);

  return (
    <div className='payment-details changes-table flex flex-col mt-4 px-20'>
      <TableContainer className='flex-auto w-full h-full !shadow-none !base-border'>
        <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby='tableTitle'>
          <TableHead>
            <TableRow>
              <TableCell className='!bg-[#F9F9F9]'>№</TableCell>
              <TableCell className='!bg-[#F9F9F9]'>
                {t('common.table.date')}
              </TableCell>
              <TableCell className='!bg-[#F9F9F9]'>
                {t('common.table.leftSum')}
              </TableCell>
              <TableCell className='!bg-[#F9F9F9]'>
                {t('common.table.paymentSum')}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody className='overflow-hidden !bg-[#FFFFFF]'>
            {stablePaymentList?.slice(0, i)?.map((row, index) => (
              <PaymentRow
                handlePaymentDate={handlePaymentDate}
                handlePaymentPrice={handlePaymentPrice}
                handleDateError={handleDateError}
                stablePaymentList={stablePaymentList}
                currency={currency}
                key={row.id}
                row={row}
                index={index}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default memo(StepThreeTabOne);
